import { Button, Result } from 'antd'
import { useNavigate } from 'react-router'

interface NotFoundProps {
  title?: string
  subTitle?: string
  backTo?: string
  backLabel?: string
}

const NotFound = ({
  title = 'Not found',
  subTitle = 'This resource doesn\'t exist or may have been deleted.',
  backTo = '/',
  backLabel = 'Go back',
}: NotFoundProps) => {
  const navigate = useNavigate()

  return (
    <Result
      status="404"
      title={title}
      subTitle={subTitle}
      extra={<Button type="primary" onClick={() => navigate(backTo)}>{backLabel}</Button>}
    />
  )
}

export default NotFound
